import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Link } from "react-router-dom";
import { Menu } from '@yisa/webui';
import { useSelector } from "react-redux";


export default (pros) => {

  const {
    type,
    onCollapsed,
    collapsed
  } = pros

  const isFirst = useRef(true)

  const [openKeys, setOpenKeys] = useState([])

  const menus = useSelector((state) => {
    return state.user.menus
  });

  const { breadcrumb, name: activeKey } = useSelector(state => state?.comment?.routerData) || {}

  const finallyMenus = useMemo(() => {
    const homeMenu = menus.find(elem => elem.path === '/home')
    const marketMenu = menus.find(elem => elem.path === '/marketManage')
    const gasMenu = menus.find(elem => elem.path === '/gasManage')
    const isMarket = breadcrumb.find(elem => elem.text === '农贸市场管理')
    const isGas = breadcrumb.find(elem => elem.text === '液化气充装管理')
    return [
      homeMenu,
      isMarket && marketMenu,
      isGas && gasMenu
    ].filter(Boolean)
  }, [menus, activeKey])

  useEffect(() => {
    isFirst.current = true
  }, [finallyMenus])

  useEffect(() => {
    if (isFirst.current && activeKey && menus.length) {
      isFirst.current = false
      try {
        menus.forEach((item, index) => {
          if (item.children && item.children.length) {
            item.children.forEach((item2) => {
              if (item2.path == activeKey) {
                setOpenKeys([item.path])
              }
              if (item2.children && item2.children.length) {
                item2.children.forEach((item3) => {
                  if (item3.path == activeKey) {
                    setOpenKeys([item.path])
                  }
                })
              }
            })
          }
        })
      } catch (error) {
      }
    }
  }, [activeKey])

  return <Menu
    openKeys={openKeys}
    data={finallyMenus}
    type={type}
    link={Link}
    onCollapsed={onCollapsed}
    inlineCollapsed={collapsed}
    activeKey={activeKey} />
}
